import jQuery from 'jquery';

/**
 * mapをレスポンシブ対応
 * use assets/js/jquery.rwdImageMaps.min.js
 */
jQuery(function () {
  jQuery('img[usemap]').rwdImageMaps();
});

const toggleMapImage = () => {
  const area = document.getElementsByTagName('area');

  if (!area) return;

  [...area].forEach(elem => {
    elem.addEventListener('mouseenter', (e) => {
      const hoverElem = e.target;

      //マップのターゲット
      const targetId = hoverElem.dataset.target;

      if (!targetId) return;

      const target = document.getElementById(targetId);

      if (!target) return;

      target.classList.add('is-active');

      //マップの文字のターゲット
      const targetTextId = hoverElem.dataset.targetText;

      if (!targetTextId) return;

      const targetText = document.getElementById(targetTextId);

      if (!targetText) return;

      targetText.classList.add('is-text-active');

    })

    elem.addEventListener('mouseleave', (e) => {
      const hoverElem = e.target;

      //マップのターゲット
      const targetId = hoverElem.dataset.target;

      if (!targetId) return;

      const target = document.getElementById(targetId);

      if (!target) return;

      target.classList.remove('is-active');

      //マップの文字のターゲット
      const targetTextId = hoverElem.dataset.targetText;

      if (!targetTextId) return;

      const targetText = document.getElementById(targetTextId);

      if (!targetText) return;

      targetText.classList.remove('is-text-active');

    })
  })
}
toggleMapImage();

const hamburgerMenuOpen = () => {
  const hamburger = document.getElementById('js-hamburger');

  if (!hamburger) return;

  hamburger.addEventListener('click', () => {
    const body = document.body;

    body.classList.add('nav-open')
  })
}
hamburgerMenuOpen();

const hamburgerMenuClose = () => {
  const closeBtn = document.getElementsByClassName('js-close');

  if (!closeBtn) return;

  [...closeBtn].forEach(elem => {
    elem.addEventListener('click', () => {
      const body = document.body;

      body.classList.remove('nav-open')
    })
  })
}
hamburgerMenuClose();